import { useEffect } from "react";

const FrameBuster = () => {

  const sanitizeURL = (url: string) => {
    const a = document.createElement("a");
    a.href = url;
    return a.href;
};

  useEffect(() => {
    document.documentElement.style.display = "none";
    document.body.style.display = "none";
    if (window.top && window.self !== window.top) {
      const safeURL = sanitizeURL(window.self.location.href);
      window.top.location = safeURL;
    } else {
      document.documentElement.style.display = "block";
      document.body.style.display = "block";
    }
  }, []);

  return null;
};

export default FrameBuster;
